import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { catchError, map, throwError } from "rxjs";
import { AlertService } from "../../shared/services/alert.service";
import { UserService } from "../services/user.service";

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
    const userService = inject(UserService);
    const router = inject(Router);
    const alertService = inject(AlertService);

    return next(req).pipe(
        map((response) => {
            if (response instanceof HttpResponse && (<any>response.body)?.code === 400) {
                throw new Error((<any>response.body)?.message || "Something went wrong");
            }
            return response;
        }),
        catchError((error) => {
            let errorMessage = "Something went wrong";

            if (error instanceof HttpErrorResponse) {
                if (error.status === 401) {
                    errorMessage = "Unauthorized access. Please login again.";
                    userService.logout();
                    void router.navigateByUrl("login");
                } else {
                    errorMessage =
                        error.error?.message || error.error || error.message || errorMessage || "Something went wrong";
                }

                alertService.openSnackBar(errorMessage);
                return throwError(() => error.error);
            }

            alertService.openSnackBar(error.message || errorMessage);
            return throwError(() => error.message);
        }),
    );
};
